// extracted by mini-css-extract-plugin
module.exports = {"lia-text-link-wrap":"LoginWidget_lia-text-link-wrap__U8mDj"};